import axios, { AxiosInstance, AxiosError } from "axios";
import { setupCache } from "axios-cache-adapter";
import { SWRResponse } from "swr";

export interface ApiArrayResponse<T> {
  data: T[];
  totalCount: number;
}

export interface ApiResponse<T> {
  data: T;
  totalCount?: number;
}

export type ServerResponse<T = ApiArrayResponse<unknown>> = SWRResponse<
  T,
  AxiosError<T>
>;

// Create `axios-cache-adapter` instance

export const getAxiosInstance = (
  url: string,
  withCache = false
): AxiosInstance => {
  const cache = setupCache({
    maxAge: 15 * 60 * 1000,
  });
  const axiosInst = axios.create({
    baseURL: url,
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
    adapter: withCache ? cache.adapter : undefined,
  });

  // Intercepts each API request and added Auth header
  axiosInst.interceptors.request.use(async (request) => {
    if (window.KEYCLOAK != null && !request.url?.includes("/token")) {
      await window.KEYCLOAK.updateToken(60);
      sessionStorage.setItem("jwt", window.KEYCLOAK.token as string);
      sessionStorage.setItem(
        "react-refresh-token",
        window.KEYCLOAK.refreshToken as string
      );
      request.headers.Authorization = `Bearer ${window.KEYCLOAK.token}`;
    }

    return request;
  });

  return axiosInst;
};
